import { render, staticRenderFns } from "./ResourceInfo.vue?vue&type=template&id=38a4bcc4"
import script from "./ResourceInfo.ts?vue&type=script&lang=ts&external"
export * from "./ResourceInfo.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports